import React from 'react'
import { Box, FormControl } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { IconButtonWithTooltip } from 'components'
import { EXEC_APPOINTMENT_PRESIDENTS } from 'utils'

interface AdministrationsMultiSelectProps {
  value: number[]
  onChange: (selectedIds: number[]) => void
  disabled?: boolean
}

export const AdministrationsMultiSelect: React.FC<AdministrationsMultiSelectProps> = ({ value, onChange, disabled = false }) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const selectedValues = Array.from(event.target.selectedOptions).map(option => Number(option.value))
    onChange(selectedValues)
  }

  const handleClear = (): void => {
    onChange([])
  }

  const options = Object.values(EXEC_APPOINTMENT_PRESIDENTS)

  return (
    <div>
      <FormControl fullWidth sx={{ height: 200 }}>
        <select
          disabled={disabled}
          multiple
          value={value.map(String)}
          onChange={handleChange}
          style={{ height: '160px', width: '100%', overflowY: 'auto' }}
        >
          {options.map((p) => (
            <option key={p.id} value={p.id.toString()}>
              {`${p.name} (${p.years})`}
            </option>
          ))}
        </select>
        {value.length > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <IconButtonWithTooltip
              label='Clear all selected'
              onClick={handleClear}
              disabled={disabled}
              color='primary'
              icon={<ClearIcon/>}
            />
          </Box>
        )}
      </FormControl>
    </div>
  )
}
